import React, { Component } from 'react'
import vision from "../../images/vision.png"
import mission from "../../images/mission.png"
import { green, maxwidth} from '../../constants'

import './Vision.css'

class Vision extends Component {
    render() {
        return (
          
                <div className='vision-outer-container'>
                    <div className='vision-inner-container'>
                        <div className='vision-subone'>
                            <div className='vision-icons'>
                                <img src={vision} ></img>
                            </div>

                            <p style={{ color: "white", fontWeight: "bold", fontSize: "40px", }}>Vision</p>
                            <span style={{ color: "black", fontSize: "16px", lineHeight: "30px", textAlign: "center", color: "white", fontWeight: "500" }}>
                                To establish a unique platform for rural and small-town
                                women and  girls to express their emotions, get safety
                                training, and develop self-reliance.</span>
                        </div>
                        <div className='divider'></div>
                        <div className='vision-subone'>
                            <div className='vision-icons'>
                                <img src={mission}></img>

                            </div>

                            <p style={{ color: "white", fontWeight: "bold", fontSize: "40px", }}>Mission</p>
                            <span style={{ color: "black", fontSize: "16px", lineHeight: "30px", textAlign: "center", color: "white", fontWeight: "500" }}>
                                To envisage an empowered rural India where, Every
                                woman gets complete safety and skill development training,
                                so they can be secure and independent in society.
                            </span>
                        </div>
                    </div>
                </div>
           
        )
    }
}

export default Vision
